import { render, staticRenderFns } from "./Duel_Button_Close.vue?vue&type=template&id=4df84df4&"
import script from "./Duel_Button_Close.vue?vue&type=script&lang=js&"
export * from "./Duel_Button_Close.vue?vue&type=script&lang=js&"
import style0 from "./Duel_Button_Close.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports